export async function extractTextFromTXT(file: File): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      try {
        const content = event.target?.result;
        if (typeof content === 'string') {
          const cleanContent = content
            .replace(/\s+/g, ' ')
            .trim();
          resolve(cleanContent || 'The text file appears to be empty');
        } else {
          resolve('Error: Invalid file content');
        }
      } catch (error) {
        console.error('TXT processing error:', error);
        resolve('Error: Could not process text file. Please try a different file.');
      }
    };
    
    reader.onerror = () => {
      resolve('Error: Could not read the file. Please try again.');
    };
    
    reader.readAsText(file);
  });
}